module.exports = __webpack_public_path__ + "img/home-header.15f5861e.jpg";